import React, { useState } from 'react';
import { createTicket } from '../api/mutations';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import IconButton from '@mui/material/IconButton';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import FormLabel from '@mui/material/FormLabel';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import BusinessIcon from '@mui/icons-material/Business';
import PersonIcon from '@mui/icons-material/Person';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import HomeIcon from '@mui/icons-material/Home';
import LocationCityIcon from '@mui/icons-material/LocationCity';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import BadgeIcon from '@mui/icons-material/Badge';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import Typography from '@mui/material/Typography';
import TurnstileWidget from '../components/TurnstileWidget';
import { apiUrl } from '../api/baseUrl';

const sections = [
  {
    title: 'Business Information',
    fields: [
      'CFLegalName', 'CFDBAName', 'CFCFTaxID', 'CFOwnershipType', 'CFCFMerchandiseServicesSold',
      'CFBusinessAddress', 'CFBusinessPostalCode', 'CFCity', 'CFBusinessState', 'CFAverageMonthlyVolume',
      'CFHighestTicketAmount', 'CFBusinessPhoneNumber', 'CFBusinessEmail', 'CFwebsite',
    ]
  },
  {
    title: 'Owner Information',
    fields: [
      'CFfirstName', 'CFlastName', 'CFCompanyNameEnrolment', 'CFOwnerAddress', 'CFOwnerCity',
      'CFOwnerState', 'CFOwnerPostcode', 'CFOwnerCellPhone', 'CFOwnerEmail', 'CFSocialSecurity', 'CFAccountManagerName'
    ]
  },
  {
    title: 'Banking & Processing',
    fields: [
      'CFBankingRoutingNumber', 'CFBankingAccountNumber', 'CFMerchantProcessingPriceModel',
      'CFCashDiscount', 'CFInterchangePlus', 'CFRateOnBPS', 'CFTransactionCost', 'CFEBTFNS'
    ]
  },
  {
    title: 'Equipment & Online Ordering',
    fields: [
      'CFTerPOS', 'CFTerminalNumber', 'CFTerminalOptions', 'CFStationsNo', 'CFhandheldsNo',
      'CFKitchenPrinters', 'CFKDSNo', 'CFCashDrawers', 'CFCDSNo', 'CFOrderingOnline',
      'CFuberEats', 'CFDoordash', 'CFGrunhub', 'CFBusinessCloseTime', 'CFHoursOfClosing',
      'CFAutoOrManual', 'CFAutoCloseWhatTime', 'CFNewBusiness', 'CFInstallationTimeframe',
      'CFTimeSlots', 'CFexistingOnlineOrdering'
    ]
  },
  {
    title: 'Attachments',
    fields: [
      'CFVoidedcheckBankinformation', 'CFDriverLicence', 'CFBusinessTaxID'
    ]
  }
];

const prodFields = [
  { name: 'CFLegalName', label: 'Legal Name', type: 'text' },
  { name: 'CFDBAName', label: 'DBA Name', type: 'text' },
  { name: 'CFCFTaxID', label: 'Tax ID', type: 'text' },
  { name: 'CFOwnershipType', label: 'Ownership Type', type: 'select', options: ['LLC', 'Corporation', 'Sale Proprietor', 'Non-Profit', 'Government'] },
  { name: 'CFCFMerchandiseServicesSold', label: 'Merchandise/Services Sold', type: 'text' },
  { name: 'CFBusinessAddress', label: 'Business Address', type: 'text' },
  { name: 'CFBusinessPostalCode', label: 'Business Postal Code', type: 'text' },
  { name: 'CFCity', label: 'City', type: 'text' },
  { name: 'CFBusinessState', label: 'Business State', type: 'text' },
  { name: 'CFAverageMonthlyVolume', label: 'Average Monthly Volume', type: 'text' },
  { name: 'CFHighestTicketAmount', label: 'Highest Ticket Amount', type: 'text' },
  { name: 'CFBusinessPhoneNumber', label: 'Business Phone Number', type: 'text' },
  { name: 'CFBusinessEmail', label: 'Business Email', type: 'email' },
  { name: 'CFwebsite', label: 'Website', type: 'text' },
  { name: 'CFBankingRoutingNumber', label: 'Banking Routing Number', type: 'text' },
  { name: 'CFBankingAccountNumber', label: 'Banking Account Number', type: 'text' },
  { name: 'CFMerchantProcessingPriceModel', label: 'Merchant Processing Price Model', type: 'text' },
  { name: 'CFfirstName', label: 'Owner First Name', type: 'text' },
  { name: 'CFlastName', label: 'Owner Last Name', type: 'text' },
  { name: 'CFCompanyNameEnrolment', label: 'Company Name Enrolment', type: 'text' },
  { name: 'CFOwnerAddress', label: 'Owner Address', type: 'text' },
  { name: 'CFOwnerCity', label: 'Owner City', type: 'text' },
  { name: 'CFOwnerState', label: 'Owner State', type: 'text' },
  { name: 'CFOwnerPostcode', label: 'Owner Postcode', type: 'text' },
  { name: 'CFOwnerCellPhone', label: 'Owner Cell Phone', type: 'text' },
  { name: 'CFOwnerEmail', label: 'Owner Email', type: 'email' },
  { name: 'CFSocialSecurity', label: 'Social Security', type: 'text' },
  { name: 'CFAccountManagerName', label: 'Account Manager Name', type: 'text' },
  { name: 'CFCashDiscount', label: 'Cash Discount', type: 'checkbox' },
  { name: 'CFInterchangePlus', label: 'Interchange Plus', type: 'checkbox' },
  { name: 'CFRateOnBPS', label: 'Rate On BPS', type: 'text' },
  { name: 'CFTransactionCost', label: 'Transaction Cost', type: 'text' },
  { name: 'CFEBTFNS', label: 'EBT FNS', type: 'text' },
  { name: 'CFTerPOS', label: 'Terminal POS', type: 'text' },
  { name: 'CFTerminalNumber', label: 'Terminal Number', type: 'text' },
  { name: 'CFTerminalOptions', label: 'Terminal Options', type: 'text' },
  { name: 'CFStationsNo', label: 'Stations No', type: 'text' },
  { name: 'CFhandheldsNo', label: 'Handhelds No', type: 'text' },
  { name: 'CFKitchenPrinters', label: 'Kitchen Printers', type: 'text' },
  { name: 'CFKDSNo', label: 'KDS No', type: 'text' },
  { name: 'CFCashDrawers', label: 'Cash Drawers', type: 'text' },
  { name: 'CFCDSNo', label: 'CDS No', type: 'text' },
  { name: 'CFOrderingOnline', label: 'Ordering Online', type: 'text' },
  { name: 'CFuberEats', label: 'Uber Eats', type: 'text' },
  { name: 'CFDoordash', label: 'Doordash', type: 'text' },
  { name: 'CFGrunhub', label: 'Grunhub', type: 'text' },
  { name: 'CFBusinessCloseTime', label: 'Business Close Time', type: 'text' },
  { name: 'CFHoursOfClosing', label: 'Hours Of Closing', type: 'text' },
  { name: 'CFAutoOrManual', label: 'Auto Or Manual', type: 'text' },
  { name: 'CFAutoCloseWhatTime', label: 'Auto Close What Time', type: 'text' },
  { name: 'CFNewBusiness', label: 'New Business', type: 'text' },
  { name: 'CFInstallationTimeframe', label: 'Installation Timeframe', type: 'text' },
  { name: 'CFTimeSlots', label: 'Time Slots', type: 'text' },
  { name: 'CFexistingOnlineOrdering', label: 'Existing Online Ordering', type: 'text' },
  { name: 'CFVoidedcheckBankinformation', label: 'Voided Check/Bank Info', type: 'text' },
  { name: 'CFDriverLicence', label: 'Driver Licence', type: 'text' },
  { name: 'CFBusinessTaxID', label: 'Business Tax ID', type: 'text' },
];

const businessTypes = [
  'Sole Proprietor',
  'LLC',
  'Corporation',
  'Partnership',
  'Non-Profit',
];

export default function ProdTicketPage({ onSuccess }) {
  const turnstileSiteKey = process.env.REACT_APP_TURNSTILE_SITE_KEY;
  const [form, setForm] = useState(Object.fromEntries(prodFields.map(f => [f.name, f.type === 'checkbox' ? false : ''])));
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [ownerDob, setOwnerDob] = useState(null);
  const [businessEstablished, setBusinessEstablished] = useState(null);
  const [yearsAtAddress, setYearsAtAddress] = useState(0);
  const [totalLocations, setTotalLocations] = useState(1);
  const [productsSold, setProductsSold] = useState('');
  const [yearsBusinessOwned, setYearsBusinessOwned] = useState(0);
  const [surroundingArea, setSurroundingArea] = useState('');
  const [premiseType, setPremiseType] = useState('');
  const [anticipatedDate, setAnticipatedDate] = useState(null);
  const [cardServices, setCardServices] = useState({
    visa: false,
    amex: false,
    debit: false,
    ebt: false
  });
  const [deliveryContact, setDeliveryContact] = useState('');
  const [bestContact, setBestContact] = useState({
    businessPhone: false,
    cellPhone: false,
    email: false
  });
  const [voidedCheckFile, setVoidedCheckFile] = useState(null);
  const [driverLicenseFile, setDriverLicenseFile] = useState(null);
  const [businessCertFile, setBusinessCertFile] = useState(null);
  const [fileErrors, setFileErrors] = useState({});
  const [captchaToken, setCaptchaToken] = useState('');
  const [captchaResetSignal, setCaptchaResetSignal] = useState(0);

  const voidedCheckInputRef = React.useRef();
  const driverLicenseInputRef = React.useRef();
  const businessCertInputRef = React.useRef();

  const handleChange = e => {
    const { name, type, value, checked } = e.target;
    setForm(f => ({ ...f, [name]: type === 'checkbox' ? checked : value }));
  };

  function validateForm() {
    const missing = [];
    if (!form.legalBusinessName) missing.push('Legal Business Name');
    if (!form.phoneNumber) missing.push('Phone Number');
    if (!form.businessAddress) missing.push('Business Address');
    if (!form.city) missing.push('City');
    if (!form.state) missing.push('State');
    if (!form.zip) missing.push('Zip');
    if (!form.email) missing.push('Email');
    if (!form.primaryOwnerName) missing.push('Primary Owner/Officer Name');
    if (!form.primaryOwnerSSN) missing.push('Primary Owner SSN');
    if (!form.primaryOwnerMobile) missing.push('Primary Owner Mobile Phone');
    if (!form.residentialAddress) missing.push('Residential Address');
    if (!form.residentialCity) missing.push('Residential City');
    if (!form.residentialState) missing.push('Residential State');
    if (!form.residentialZip) missing.push('Residential Zip');
    if (!form.federalTaxId) missing.push('Federal Tax ID');
    const fileErrs = {};
    if (!voidedCheckFile) fileErrs.voidedCheck = 'Required';
    if (!driverLicenseFile) fileErrs.driverLicense = 'Required';
    if (!businessCertFile) fileErrs.businessCert = 'Required';
    setFileErrors(fileErrs);
    if (Object.keys(fileErrs).length > 0) missing.push('Attachments');
    return missing;
  }

  const handleFileChange = (e, setter) => {
    if (e.target.files && e.target.files[0]) {
      setter(e.target.files[0]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setFileErrors({});
    const missing = validateForm();
    if (missing.length > 0) {
      setError('Please fill all required fields and upload all required attachments.');
      setLoading(false);
      return;
    }
    if (turnstileSiteKey && !captchaToken) {
      setError('Please complete captcha verification.');
      setLoading(false);
      return;
    }
    try {
      const formData = new FormData();
      // Only send non-empty, non-CF fields
      Object.entries(form).forEach(([key, value]) => {
        if (value !== '' && value !== false && !key.startsWith('CF')) {
          formData.append(key, value);
        }
      });
      formData.append('productsSold', productsSold);
      formData.append('yearsBusinessOwned', yearsBusinessOwned);
      formData.append('surroundingArea', surroundingArea);
      formData.append('premiseType', premiseType);
      formData.append('businessEstablished', businessEstablished ? businessEstablished.toISOString() : '');
      formData.append('anticipatedDate', anticipatedDate ? anticipatedDate.toISOString() : '');
      formData.append('ownerDob', ownerDob ? ownerDob.toISOString() : '');
      formData.append('yearsAtAddress', yearsAtAddress);
      formData.append('totalLocations', totalLocations);
      formData.append('cardServices', JSON.stringify(cardServices));
      formData.append('deliveryContact', deliveryContact);
      formData.append('bestContact', JSON.stringify(bestContact));
      formData.append('voidedCheck', voidedCheckFile);
      formData.append('driverLicense', driverLicenseFile);
      formData.append('businessCert', businessCertFile);
      if (captchaToken) {
        formData.append('captchaToken', captchaToken);
      }
      const res = await fetch(apiUrl('/api/apply'), {
        method: 'POST',
        body: formData
      });
      if (res.ok) {
        setForm(Object.fromEntries(prodFields.map(f => [f.name, f.type === 'checkbox' ? false : ''])));
        setVoidedCheckFile(null);
        setDriverLicenseFile(null);
        setBusinessCertFile(null);
        setCaptchaToken('');
        setCaptchaResetSignal((value) => value + 1);
        onSuccess();
      } else {
        const err = await res.json();
        setError(err.error || 'Submission failed');
        setCaptchaToken('');
        setCaptchaResetSignal((value) => value + 1);
      }
    } catch (err) {
      setError(err.message);
      setCaptchaToken('');
      setCaptchaResetSignal((value) => value + 1);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      minHeight: '100vh',
      justifyContent: 'flex-start',
      background: '#f5f7fa',
      px: { xs: 0, sm: 0 },
    }}>
      <Box sx={{
        bgcolor: '#fff',
        border: { xs: '2px solid #000', sm: '6px solid #000' },
        borderRadius: 4,
        boxShadow: 4,
        px: { xs: 1, sm: 6 },
        py: { xs: 1, sm: 5 },
        mx: 'auto',
        width: { xs: '100vw', sm: 'auto' },
        maxWidth: { xs: '100vw', sm: 1100 },
      }}>
        <h2 style={{textAlign: 'center', fontWeight: 700, fontSize: 24, marginBottom: 12, letterSpacing: 0.5}}>Merchant Services Application Form</h2>
        <div style={{
          textAlign: 'center',
          fontSize: 15,
          color: '#222',
          marginBottom: 24,
          fontWeight: 500,
        }}>
          Business Profile for Merchant Services (Information for application purposes only and is not a guarantee of acceptance).<br/>
          <b>Please Note:</b> The personal information you supply will be used only for the purpose of qualifying for a merchant account by Kleos Group. This information is held in the strictest confidence and is never sold, rented, or shared with any other business or third-party.
        </div>
        <Box component="form" autoComplete="off" sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: 2, sm: 3 },
        }} onSubmit={handleSubmit}>
          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mb: 2 }}>
            <TextField
              fullWidth
              label="Business/DBA Name"
              name="businessDbaName"
              variant="outlined"
              required
              value={form.businessDbaName || ''}
              onChange={handleChange}
              placeholder="Business/DBA Name"
              InputProps={{ startAdornment: <BusinessIcon sx={{ mr: 1, color: '#1976d2' }} /> }}
              sx={{ mb: { xs: 2, sm: 0 } }}
            />
            <TextField
              fullWidth
              label="Main Business Contact Name"
              name="mainContactName"
              variant="outlined"
              required
              value={form.mainContactName || ''}
              onChange={handleChange}
              placeholder="Main Business Contact Name"
              InputProps={{ startAdornment: <PersonIcon sx={{ mr: 1, color: '#1976d2' }} /> }}
            />
          </Box>
          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mb: 2 }}>
            <TextField
              fullWidth
              label="Legal Business Name"
              name="legalBusinessName"
              variant="outlined"
              required
              value={form.legalBusinessName || ''}
              onChange={handleChange}
              placeholder="Legal Business Name"
              InputProps={{ startAdornment: <BusinessIcon sx={{ mr: 1, color: '#1976d2' }} /> }}
              sx={{ mb: { xs: 2, sm: 0 } }}
            />
            <TextField
              fullWidth
              label="Phone Number"
              name="phoneNumber"
              variant="outlined"
              required
              value={form.phoneNumber || ''}
              onChange={handleChange}
              placeholder="Phone Number"
              InputProps={{ startAdornment: <PhoneIcon sx={{ mr: 1, color: '#1976d2' }} /> }}
            />
          </Box>
          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mb: 2 }}>
            <TextField
              fullWidth
              label="Business Address"
              name="businessAddress"
              variant="outlined"
              required
              value={form.businessAddress || ''}
              onChange={handleChange}
              placeholder="Business Address"
              InputProps={{ startAdornment: <HomeIcon sx={{ mr: 1, color: '#1976d2' }} /> }}
              sx={{ mb: { xs: 2, sm: 0 } }}
            />
            <TextField
              fullWidth
              label="Fax Number"
              name="faxNumber"
              variant="outlined"
              value={form.faxNumber || ''}
              onChange={handleChange}
              placeholder="Fax Number"
              InputProps={{ startAdornment: <PhoneIcon sx={{ mr: 1, color: '#1976d2' }} /> }}
            />
          </Box>
          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mb: 2 }}>
            <TextField
              fullWidth
              label="City"
              name="city"
              variant="outlined"
              required
              value={form.city || ''}
              onChange={handleChange}
              placeholder="City"
              InputProps={{ startAdornment: <LocationCityIcon sx={{ mr: 1, color: '#1976d2' }} /> }}
              sx={{ mb: { xs: 2, sm: 0 } }}
            />
            <TextField
              fullWidth
              label="State"
              name="state"
              variant="outlined"
              required
              value={form.state || ''}
              onChange={handleChange}
              placeholder="State"
              InputProps={{ startAdornment: <LocationCityIcon sx={{ mr: 1, color: '#1976d2' }} /> }}
              sx={{ mb: { xs: 2, sm: 0 } }}
            />
            <TextField
              fullWidth
              label="Zip"
              name="zip"
              variant="outlined"
              required
              value={form.zip || ''}
              onChange={handleChange}
              placeholder="Zip"
              InputProps={{ startAdornment: <LocationCityIcon sx={{ mr: 1, color: '#1976d2' }} /> }}
              sx={{ mb: { xs: 2, sm: 0 } }}
            />
            <TextField
              fullWidth
              label="Email"
              name="email"
              variant="outlined"
              required
              value={form.email || ''}
              onChange={handleChange}
              placeholder="Email"
              InputProps={{ startAdornment: <EmailIcon sx={{ mr: 1, color: '#1976d2' }} /> }}
            />
          </Box>
          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mb: 2 }}>
            <TextField
              fullWidth
              label="Website"
              name="website"
              variant="outlined"
              value={form.website || ''}
              onChange={handleChange}
              placeholder="Website"
              InputProps={{ startAdornment: <HomeIcon sx={{ mr: 1, color: '#1976d2' }} /> }}
              sx={{ mb: { xs: 2, sm: 0 } }}
            />
            <TextField
              select
              fullWidth
              label="Business Type"
              name="businessType"
              variant="outlined"
              required
              value={form.businessType || ''}
              onChange={handleChange}
              placeholder="Business Type"
              InputProps={{ startAdornment: <BusinessIcon sx={{ mr: 1, color: '#1976d2' }} /> }}
            >
              {businessTypes.map(type => (
                <MenuItem key={type} value={type}>{type}</MenuItem>
              ))}
            </TextField>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mb: 2 }}>
            <FormControl fullWidth sx={{ flex: 1 }}>
              <InputLabel>Products/Services Sold</InputLabel>
              <Select
                value={productsSold}
                label="Products/Services Sold"
                onChange={e => setProductsSold(e.target.value)}
              >
                <MenuItem value="Food & Beverage">Food & Beverage</MenuItem>
                <MenuItem value="Liquor">Liquor</MenuItem>
                <MenuItem value="Gas/Oil">Gas/Oil</MenuItem>
                <MenuItem value="Other Retail">Other Retail</MenuItem>
                <MenuItem value="Other Service">Other Service</MenuItem>
              </Select>
            </FormControl>
            <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
              <IconButton onClick={() => setYearsBusinessOwned(Math.max(0, yearsBusinessOwned - 1))}><RemoveIcon /></IconButton>
              <TextField
                label="Years Business Owned"
                value={yearsBusinessOwned}
                inputProps={{ readOnly: true, style: { textAlign: 'center' } }}
                sx={{ width: '100%' }}
              />
              <IconButton onClick={() => setYearsBusinessOwned(yearsBusinessOwned + 1)}><AddIcon /></IconButton>
            </Box>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mb: 2 }}>
            <FormControl fullWidth sx={{ flex: 1 }}>
              <InputLabel>Surrounding Area</InputLabel>
              <Select
                value={surroundingArea}
                label="Surrounding Area"
                onChange={e => setSurroundingArea(e.target.value)}
              >
                <MenuItem value="Commercial">Commercial</MenuItem>
                <MenuItem value="Residential">Residential</MenuItem>
                <MenuItem value="Industrial">Industrial</MenuItem>
              </Select>
            </FormControl>
            <FormControl fullWidth sx={{ flex: 1 }}>
              <InputLabel>Is the Premise</InputLabel>
              <Select
                value={premiseType}
                label="Is the Premise"
                onChange={e => setPremiseType(e.target.value)}
              >
                <MenuItem value="Leased">Leased</MenuItem>
                <MenuItem value="Owned">Owned</MenuItem>
              </Select>
            </FormControl>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mb: 2 }}>
            <DatePicker
              label="Date of Business Established"
              value={businessEstablished}
              onChange={setBusinessEstablished}
              slotProps={{ textField: { fullWidth: true, required: true, variant: 'outlined', InputProps: { startAdornment: <CalendarTodayIcon sx={{ mr: 1, color: '#1976d2' }} /> } } }}
            />
          </Box>
          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mb: 2 }}>
            <DatePicker
              label="Anticipated Date to Begin Processing"
              value={anticipatedDate}
              onChange={setAnticipatedDate}
              slotProps={{ textField: { fullWidth: true, required: true, variant: 'outlined', InputProps: { startAdornment: <CalendarTodayIcon sx={{ mr: 1, color: '#1976d2' }} /> } } }}
            />
          </Box>
          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mb: 2 }}>
            <TextField
              fullWidth
              label="Primary Owner/Officer Name"
              name="primaryOwnerName"
              variant="outlined"
              required
              value={form.primaryOwnerName || ''}
              onChange={handleChange}
              placeholder="Primary Owner/Officer Name"
              InputProps={{ startAdornment: <PersonIcon sx={{ mr: 1, color: '#1976d2' }} /> }}
            />
          </Box>
          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mb: 2 }}>
            <TextField
              fullWidth
              label="Primary Owner SSN"
              name="primaryOwnerSSN"
              variant="outlined"
              required
              value={form.primaryOwnerSSN || ''}
              onChange={handleChange}
              placeholder="Primary Owner SSN"
              InputProps={{ startAdornment: <BadgeIcon sx={{ mr: 1, color: '#1976d2' }} /> }}
            />
            <DatePicker
              label="Date of Birth"
              value={ownerDob}
              onChange={setOwnerDob}
              slotProps={{ textField: { fullWidth: true, required: true, variant: 'outlined', InputProps: { startAdornment: <CalendarTodayIcon sx={{ mr: 1, color: '#1976d2' }} /> } } }}
            />
          </Box>
          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mb: 2 }}>
            <TextField
              fullWidth
              label="Primary Owner Mobile Phone"
              name="primaryOwnerMobile"
              variant="outlined"
              required
              value={form.primaryOwnerMobile || ''}
              onChange={handleChange}
              placeholder="Primary Owner Mobile Phone"
              InputProps={{ startAdornment: <PhoneIcon sx={{ mr: 1, color: '#1976d2' }} /> }}
            />
          </Box>
          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mb: 2 }}>
            <TextField
              fullWidth
              label="Residential Address"
              name="residentialAddress"
              variant="outlined"
              required
              value={form.residentialAddress || ''}
              onChange={handleChange}
              placeholder="Residential Address"
              InputProps={{ startAdornment: <HomeIcon sx={{ mr: 1, color: '#1976d2' }} /> }}
            />
          </Box>
          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mb: 2 }}>
            <TextField
              fullWidth
              label="City"
              name="residentialCity"
              variant="outlined"
              required
              value={form.residentialCity || ''}
              onChange={handleChange}
              placeholder="City"
              InputProps={{ startAdornment: <LocationCityIcon sx={{ mr: 1, color: '#1976d2' }} /> }}
            />
            <TextField
              fullWidth
              label="State"
              name="residentialState"
              variant="outlined"
              required
              value={form.residentialState || ''}
              onChange={handleChange}
              placeholder="State"
              InputProps={{ startAdornment: <LocationCityIcon sx={{ mr: 1, color: '#1976d2' }} /> }}
            />
            <TextField
              fullWidth
              label="Zip Code"
              name="residentialZip"
              variant="outlined"
              required
              value={form.residentialZip || ''}
              onChange={handleChange}
              placeholder="Zip Code"
              InputProps={{ startAdornment: <LocationCityIcon sx={{ mr: 1, color: '#1976d2' }} /> }}
            />
          </Box>
          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mb: 2, alignItems: 'center' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
              <IconButton onClick={() => setYearsAtAddress(Math.max(0, yearsAtAddress - 1))}><RemoveIcon /></IconButton>
              <TextField
                label="Years at this Address"
                value={yearsAtAddress}
                inputProps={{ readOnly: true, style: { textAlign: 'center' } }}
                sx={{ width: '100%' }}
              />
              <IconButton onClick={() => setYearsAtAddress(yearsAtAddress + 1)}><AddIcon /></IconButton>
            </Box>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mb: 2 }}>
            <TextField
              fullWidth
              label="Average Ticket $"
              name="averageTicket"
              variant="outlined"
              required
              value={form.averageTicket || ''}
              onChange={handleChange}
              placeholder="Average Ticket $"
              InputProps={{ startAdornment: <AttachMoneyIcon sx={{ mr: 1, color: '#1976d2' }} /> }}
            />
            <TextField
              fullWidth
              label="Annual Visa/MC/Discover Sales"
              name="annualCardSales"
              variant="outlined"
              required
              value={form.annualCardSales || ''}
              onChange={handleChange}
              placeholder="Annual Visa/MC/Discover Sales"
              InputProps={{ startAdornment: <CreditCardIcon sx={{ mr: 1, color: '#1976d2' }} /> }}
            />
          </Box>
          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mb: 2, alignItems: 'center' }}>
            <TextField
              fullWidth
              label="Federal Tax ID #"
              name="federalTaxId"
              variant="outlined"
              required
              value={form.federalTaxId || ''}
              onChange={handleChange}
              placeholder="Federal Tax ID #"
              sx={{ flex: 1 }}
            />
            <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
              <IconButton onClick={() => setTotalLocations(Math.max(1, totalLocations - 1))}><RemoveIcon /></IconButton>
              <TextField
                label="Total # of Locations"
                value={totalLocations}
                inputProps={{ readOnly: true, style: { textAlign: 'center' } }}
                sx={{ width: '100%' }}
              />
              <IconButton onClick={() => setTotalLocations(totalLocations + 1)}><AddIcon /></IconButton>
            </Box>
          </Box>
          <Box sx={{ mb: 2 }}>
            <FormLabel sx={{ color: '#222', fontWeight: 600, display: 'block', textAlign: 'left', mb: 1 }}>
              Application for the following card services:
            </FormLabel>
            <FormGroup row>
              <FormControlLabel
                control={<Checkbox checked={cardServices.visa} onChange={e => setCardServices(cs => ({ ...cs, visa: e.target.checked }))} sx={{ color: '#1976d2' }} />}
                label={<span style={{ color: '#222', fontWeight: 500 }}>Visa/MasterCard/Discover</span>}
              />
              <FormControlLabel
                control={<Checkbox checked={cardServices.amex} onChange={e => setCardServices(cs => ({ ...cs, amex: e.target.checked }))} sx={{ color: '#1976d2' }} />}
                label={<span style={{ color: '#222', fontWeight: 500 }}>American Express</span>}
              />
              <FormControlLabel
                control={<Checkbox checked={cardServices.debit} onChange={e => setCardServices(cs => ({ ...cs, debit: e.target.checked }))} sx={{ color: '#1976d2' }} />}
                label={<span style={{ color: '#222', fontWeight: 500 }}>PIN-Based Debit</span>}
              />
              <FormControlLabel
                control={<Checkbox checked={cardServices.ebt} onChange={e => setCardServices(cs => ({ ...cs, ebt: e.target.checked }))} sx={{ color: '#1976d2' }} />}
                label={<span style={{ color: '#222', fontWeight: 500 }}>EBT</span>}
              />
            </FormGroup>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mb: 2 }}>
            <TextField
              fullWidth
              label="What email or fax number would you like us to send your application to?"
              name="deliveryContact"
              variant="outlined"
              value={deliveryContact}
              onChange={e => setDeliveryContact(e.target.value)}
              placeholder="Email or Fax Number"
            />
          </Box>
          <Box sx={{ mb: 2 }}>
            <FormLabel sx={{ color: '#222', fontWeight: 600, display: 'block', textAlign: 'left', mb: 1 }}>
              What is the best way to contact you?
            </FormLabel>
            <FormGroup row>
              <FormControlLabel
                control={<Checkbox checked={bestContact.businessPhone} onChange={e => setBestContact(bc => ({ ...bc, businessPhone: e.target.checked }))} sx={{ color: '#1976d2' }} />}
                label={<span style={{ color: '#222', fontWeight: 500 }}>Business Phone</span>}
              />
              <FormControlLabel
                control={<Checkbox checked={bestContact.cellPhone} onChange={e => setBestContact(bc => ({ ...bc, cellPhone: e.target.checked }))} sx={{ color: '#1976d2' }} />}
                label={<span style={{ color: '#222', fontWeight: 500 }}>Cell Phone</span>}
              />
              <FormControlLabel
                control={<Checkbox checked={bestContact.email} onChange={e => setBestContact(bc => ({ ...bc, email: e.target.checked }))} sx={{ color: '#1976d2' }} />}
                label={<span style={{ color: '#222', fontWeight: 500 }}>Email</span>}
              />
            </FormGroup>
          </Box>
          <Box sx={{ mb: 2 }}>
            <FormLabel sx={{ color: '#222', fontWeight: 600 }}>Upload picture of business voided check for deposits <span style={{color:'#c00'}}>*</span></FormLabel>
            <Box
              sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 90, border: '2px dashed #1976d2', borderRadius: 2, bgcolor: '#f5f7fa', cursor: 'pointer', mb: 1 }}
              onClick={() => voidedCheckInputRef.current.click()}
            >
              <CloudUploadIcon sx={{ fontSize: 40, color: '#1976d2' }} />
              <Typography sx={{ ml: 2 }}>{voidedCheckFile ? voidedCheckFile.name : 'Click to upload'}</Typography>
            </Box>
            <input type="file" style={{ display: 'none' }} ref={voidedCheckInputRef} onChange={e => handleFileChange(e, setVoidedCheckFile)} accept="image/*,application/pdf" />
            {fileErrors.voidedCheck && <Typography color="error" fontSize={13}>{fileErrors.voidedCheck}</Typography>}
          </Box>
          <Box sx={{ mb: 2 }}>
            <FormLabel sx={{ color: '#222', fontWeight: 600 }}>Upload picture of owner's driving license or ID <span style={{color:'#c00'}}>*</span></FormLabel>
            <Box
              sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 90, border: '2px dashed #1976d2', borderRadius: 2, bgcolor: '#f5f7fa', cursor: 'pointer', mb: 1 }}
              onClick={() => driverLicenseInputRef.current.click()}
            >
              <CloudUploadIcon sx={{ fontSize: 40, color: '#1976d2' }} />
              <Typography sx={{ ml: 2 }}>{driverLicenseFile ? driverLicenseFile.name : 'Click to upload'}</Typography>
            </Box>
            <input type="file" style={{ display: 'none' }} ref={driverLicenseInputRef} onChange={e => handleFileChange(e, setDriverLicenseFile)} accept="image/*,application/pdf" />
            {fileErrors.driverLicense && <Typography color="error" fontSize={13}>{fileErrors.driverLicense}</Typography>}
          </Box>
          <Box sx={{ mb: 2 }}>
            <FormLabel sx={{ color: '#222', fontWeight: 600 }}>Upload business certificate with EIN # and business address <span style={{color:'#c00'}}>*</span></FormLabel>
            <Box
              sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 90, border: '2px dashed #1976d2', borderRadius: 2, bgcolor: '#f5f7fa', cursor: 'pointer', mb: 1 }}
              onClick={() => businessCertInputRef.current.click()}
            >
              <CloudUploadIcon sx={{ fontSize: 40, color: '#1976d2' }} />
              <Typography sx={{ ml: 2 }}>{businessCertFile ? businessCertFile.name : 'Click to upload'}</Typography>
            </Box>
            <input type="file" style={{ display: 'none' }} ref={businessCertInputRef} onChange={e => handleFileChange(e, setBusinessCertFile)} accept="image/*,application/pdf" />
            {fileErrors.businessCert && <Typography color="error" fontSize={13}>{fileErrors.businessCert}</Typography>}
          </Box>
          <Box sx={{ mb: 2, mt: 3, p: 2, bgcolor: '#f5f7fa', borderRadius: 2, border: '1px solid #1976d2' }}>
            <span style={{ color: '#1976d2', fontWeight: 600 }}>
              Disclaimer:
            </span> <span style={{ color: '#222', fontWeight: 500 }}>This is not the final step of the process. Kleos Group will take this info and send an application to you for your review. Your processing account can be set up a few days after you return your signed official application.</span>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 2, mb: 2 }}>
            <TextField
              fullWidth
              label="Agent Name (optional)"
              name="agentName"
              variant="outlined"
              value={form.agentName || ''}
              onChange={handleChange}
              placeholder="Agent Name (optional)"
            />
          </Box>
          {turnstileSiteKey && (
            <Box sx={{ mb: 2 }}>
              <TurnstileWidget
                siteKey={turnstileSiteKey}
                onTokenChange={setCaptchaToken}
                resetSignal={captchaResetSignal}
              />
            </Box>
          )}
          <Button
            type="submit"
            variant="contained"
            color="success"
            sx={{
              mt: 3,
              fontWeight: 700,
              fontSize: 18,
              borderRadius: 2,
              py: 1.5,
              boxShadow: 2,
            }}
            disabled={loading}
          >
            {loading ? 'Submitting...' : 'Submit Application'}
          </Button>
          {error && <div className="form-error" style={{color: '#c00', fontWeight: 600, marginTop: 18, textAlign: 'center'}}>{error}</div>}
        </Box>
      </Box>
    </Box>
  );
}
